/**
 * dragResize — 三栏拖拽调整宽度
 *
 * 用法：
 *   attachDragResize(splitterEl, onDelta)
 *   - 拖动时回调 onDelta(dxPixels)，由调用方决定如何更新 CSS 变量
 *   - 双击分隔条触发 onToggleCollapse()
 *
 * 拖动期间给 body 加 .TaroShell-dragging（禁选中/iframe穿透）
 */

const DRAGGING_CLASS = 'TaroShell-dragging';

export function attachDragResize(splitter, handlers) {
  if (!splitter) return;

  let dragging = false;
  let startX = 0;

  function onMouseDown(e) {
    if (e.button !== 0) return;
    dragging = true;
    startX = e.clientX;
    splitter.classList.add('is-dragging');
    document.body.classList.add(DRAGGING_CLASS);

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    e.preventDefault();
  }

  function onMouseMove(e) {
    if (!dragging) return;
    const dx = e.clientX - startX;
    startX = e.clientX;
    if (handlers.onDelta) handlers.onDelta(dx);
  }

  function onMouseUp() {
    dragging = false;
    splitter.classList.remove('is-dragging');
    document.body.classList.remove(DRAGGING_CLASS);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    if (handlers.onEnd) handlers.onEnd();
  }

  function onDblClick() {
    if (handlers.onToggleCollapse) handlers.onToggleCollapse();
  }

  splitter.addEventListener('mousedown', onMouseDown);
  splitter.addEventListener('dblclick', onDblClick);

  return function detach() {
    splitter.removeEventListener('mousedown', onMouseDown);
    splitter.removeEventListener('dblclick', onDblClick);
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };
}
